import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { CashbackFacade } from '@features/cashback/facades/cashback.facade';
import { CashbackFormData } from '@features/cashback/types';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class FormDataGuard {
  constructor(private router: Router, private cashbackFacade: CashbackFacade) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> {
    return this.cashbackFacade.cashbackForm$.pipe(
      map((formData) => {
        // @ts-ignore
        if (this.formDataFilled(formData)) {
          return true;
        } else {
          this.router.navigate(['/redeem_cash/checkout']);

          return false;
        }
      }),
    );
  }

  private formDataFilled(formData: CashbackFormData): boolean {
    return !!formData && formData.sourceAmount !== null;
  }
}
